import {
  Directive,
  ElementRef,
  inject,
  input,
  OnInit,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appQmSanitise]',
  standalone: true,
})
export class QMSanitiseDirective implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly hostElement = inject(ElementRef);

  appQmSanitise = input<'block' | 'encrypt'>();

  ngOnInit(): void {
    switch (this.appQmSanitise()) {
      case 'block':
        this.setAttribute('data-qm-block');
        return;
      case 'encrypt':
        this.setAttribute('data-qm-encrypt');
        return;
      default:
        return;
    }
  }

  private setAttribute(name: string): void {
    this.renderer.setAttribute(this.hostElement.nativeElement, name, 'true');
  }
}
